import { OrganizerType } from "../../../../../../shared/types/OrganizerTypes"
import { ServiceCenterBookingOrganizer } from "../../serviceCenterHomeTypes"

export function getHostOrganizerName(organizers?: Array<ServiceCenterBookingOrganizer>) {
    if (!Array.isArray(organizers) || organizers.length === 0) return ""

    const responsible = organizers.find((org) => org?.type === OrganizerType.RESPONSIBLE && org?.name)
    if (responsible) return responsible.name

    const organizer = organizers.find((org) => org?.type === OrganizerType.ORGANIZER && org?.name)
    return organizer ? organizer.name : ""
}

export function getHostOrganizer(
    organizers?: Array<ServiceCenterBookingOrganizer>,
): ServiceCenterBookingOrganizer | null {
    if (!Array.isArray(organizers) || organizers.length === 0) return null

    const organizer = organizers.find((org) => org?.type === OrganizerType.ORGANIZER && org?.name)
    return organizer ?? null
}

export function getHostOrganizerCompanyName(organizers?: Array<ServiceCenterBookingOrganizer>) {
    if (!Array.isArray(organizers) || organizers.length === 0) return ""

    const responsible = organizers.find((org) => org?.type === OrganizerType.RESPONSIBLE && org?.company?.name)
    if (responsible) return responsible.company?.name

    const organizer = organizers.find((org) => org?.type === OrganizerType.ORGANIZER && org?.company?.name)
    return organizer ? organizer.company?.name : ""
}
